<form [formGroup]="form">
  <div class="flex margin-top-15 f-gap--10px" formGroupName="accidentsAxa">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">ACCIDENTES AXA</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="accidentsAxa.productName || ''"></howden-label-value>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex f-gap--10px" style="align-items:flex-start;">

          <div class="f-basis--6">
            <div class="flex f-gap--10px">
              <div class="f-basis--2">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Fallecimiento</mat-label>
                  <input matInput type="number" inputmode="decimal" min="0" step="any"
                         formControlName="aAxaCapitalDeath"
                         [howdenControlError]="aAxaCapitalDeathError"
                         [howdenMax]="9999999"/>
                  <mat-error #aAxaCapitalDeathError></mat-error>
                </mat-form-field>
              </div>

              <div class="f-basis--2">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">F. Accte. Circulación</mat-label>
                  <input matInput type="number" inputmode="decimal" min="0" step="any"
                         formControlName="aAxaCapitalDeathTrafficAccident"
                         [howdenControlError]="aAxaCapitalDeathTrafficAccidentError"
                         [howdenMax]="9999999"/>
                  <mat-error #aAxaCapitalDeathTrafficAccidentError></mat-error>
                </mat-form-field>
              </div>

              <div class="f-basis--2">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Infarto</mat-label>
                  <input matInput type="number" inputmode="decimal" min="0" step="any"
                         formControlName="aAxaCapitalHeartAttack"
                         [howdenControlError]="aAxaCapitalHeartAttackError"
                         [howdenMax]="9999999"/>
                  <mat-error #aAxaCapitalHeartAttackError></mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="flex f-gap--10px">
              <div class="f-basis--5">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Inv. Per. Pro.</mat-label>
                  <mat-select formControlName="aAxaCapitalDisabilityType"
                              [compareWith]="compareByIdNumber"
                              [howdenControlError]="aAxaCapitalDisabilityTypeError">
                    @for (item of accidentsAxa.getMasterValues('S_AXA_CAPITALDISABILITYTYPE'); track item.id) {
                      <mat-option [value]="item.id">{{ item.description }}</mat-option>
                    } @empty {
                      <mat-option disabled>No hay opciones disponibles</mat-option>
                    }
                  </mat-select>
                  <mat-error #aAxaCapitalDisabilityTypeError></mat-error>
                </mat-form-field>
              </div>

              <div class="f-basis--1">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Valor</mat-label>
                  <input matInput type="number" inputmode="decimal" min="0" step="any"
                         formControlName="aAxaCapitalDisability"
                         [howdenControlError]="aAxaCapitalDisabilityError"
                         [howdenMax]="9999999"/>
                  <mat-error #aAxaCapitalDisabilityError></mat-error>
                </mat-form-field>
              </div>

              <div class="f-basis--3">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Invalidez Perm. Accte. Circulación</mat-label>
                  <input matInput type="number" inputmode="decimal" min="0" step="any"
                         formControlName="aAxaCapitalPermanentDisabilityTrafficAccident"
                         [howdenControlError]="aAxaCapitalPermanentDisabilityTrafficAccidentError"
                         [howdenMax]="9999999"/>
                  <mat-error #aAxaCapitalPermanentDisabilityTrafficAccidentError></mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="flex f-gap--10px">
              <div class="f-basis--3">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Gastos Médicos por Accidente</mat-label>
                  <input matInput type="number" inputmode="decimal" min="0" step="any"
                         formControlName="aAxaCapitalMedicalExpensesForAccidents"
                         [howdenControlError]="aAxaCapitalMedicalExpensesForAccidentsError"
                         [howdenMax]="9999999"/>
                  <mat-error #aAxaCapitalMedicalExpensesForAccidentsError></mat-error>
                </mat-form-field>
              </div>

              <div class="f-basis--3">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Hospitalización por Enfermedad o Accidente</mat-label>
                  <input matInput type="number" inputmode="decimal" min="0" step="any"
                         formControlName="aAxaCapitalHospitalizationIllnessAccident"
                         [howdenControlError]="aAxaCapitalHospitalizationIllnessAccidentError"
                         [howdenMax]="9999999"/>
                  <mat-error #aAxaCapitalHospitalizationIllnessAccidentError></mat-error>
                </mat-form-field>
              </div>

              <div class="f-basis--3">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Asistencia Familiar por Accidente</mat-label>
                  <mat-select formControlName="aAxaCapitalFamilyAccidentAssistance"
                              [compareWith]="compareByIdBoolean"
                              [howdenControlError]="aAxaCapitalFamilyAccidentAssistanceError">
                    @for (item of (accidentsAxa.getMasterValues('S_AXA_CAPITALFAMILYACCIDENTASSISTANCE') | howdenArraySort:'description'); track item.id) {
                      <mat-option [value]="item.id">{{ item.description }}</mat-option>
                    } @empty {
                      <mat-option disabled>No hay opciones disponibles</mat-option>
                    }
                  </mat-select>
                  <mat-error #aAxaCapitalFamilyAccidentAssistanceError></mat-error>
                </mat-form-field>
              </div>

              @if (showHivAxa) {
                <div class="f-basis--2">
                  <mat-form-field class="field-inputs">
                    <mat-label i18n="@@app.sane-projects.calculator.label">VIH / Hepatitis</mat-label>

                    <mat-select formControlName="aAxaCapitalHIVHepatitisInfection"
                                [compareWith]="compareByIdNumber"
                                [howdenControlError]="aAxaCapitalHIVHepatitisInfectionError">
                                @for (item of (accidentsAxa.getMasterValues('S_AXA_CAPITALHIVHEPATITISINFECTION') | howdenArraySort:'description'); track item.id) {
                        <mat-option [value]="item.id">{{ item.description }}</mat-option>
                      } @empty {
                        <mat-option disabled>No hay opciones disponibles</mat-option>
                      }
                    </mat-select>

                    <mat-error #aAxaCapitalHIVHepatitisInfectionError></mat-error>
                  </mat-form-field>
                </div>
              }
            </div>
          </div>

          @if (showTrace(accidentsAxa)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(accidentsAxa) || ''"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus" style="flex-direction: column;">
            @if (accidentsAxa.chargeable) {
              <howden-label-value labelText="Prima" [value]="accidentsAxa.bonus | bonus"></howden-label-value>
              <br />
            } @else {
              @for (m of getMessages(accidentsAxa); track $index) {
                @if (m.blocking) {
                  <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                  <br />
                }
              }
            }

            @for (m of getMessages(accidentsAxa); track $index) {
              @if (!m.blocking) {
                <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
                <br />
              }
            }
          </div>

        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="flex margin-top-15 f-gap--10px" formGroupName="accidentsSurne">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">ACCIDENTES SURNE</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="accidentsSurne.productName || ''"></howden-label-value>
      </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content class="margin-top-15">
      <div class="flex f-gap--10px" style="align-items:flex-start;">

        <div class="f-basis--6">
          <div class="flex f-gap--10px">
            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.label">Fallecimiento</mat-label>
                <input matInput type="number" inputmode="decimal" min="0" step="any"
                       formControlName="aSurneCapitalDeath"
                       [howdenControlError]="aSurneCapitalDeathError"
                       [howdenMax]="9999999"/>
                <mat-error #aSurneCapitalDeathError></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--1">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.label">Infarto</mat-label>
                <input matInput type="number" inputmode="decimal" min="0" step="any"
                       formControlName="aSurneCapitalHeartAttack"
                       [howdenControlError]="aSurneCapitalHeartAttackError"
                       [howdenMax]="9999999"/>
                <mat-error #aSurneCapitalHeartAttackError></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--4">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.label">Inv. Abstr. Baremo E.</mat-label>
                <mat-select formControlName="aSurneCapitalAbsoluteDisabilityType"
                            [compareWith]="compareByIdNumber"
                            [howdenControlError]="aSurneCapitalAbsoluteDisabilityTypeError">
                  @for (item of (accidentsSurne.getMasterValues('S_SURNE_CAPITALABSOLUTEDISABILITYTYPE') | howdenArraySort:'description'); track item.id) {
                    <mat-option [value]="item.id">{{ item.description }}</mat-option>
                  } @empty {
                    <mat-option disabled>No hay opciones disponibles</mat-option>
                  }
                </mat-select>
                <mat-error #aSurneCapitalAbsoluteDisabilityTypeError></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.label">Total Invalidez</mat-label>
                <input matInput type="number" inputmode="decimal" min="0" step="any"
                       formControlName="aSurneCapitalAbsoluteDisability"
                       [howdenControlError]="aSurneCapitalAbsoluteDisabilityError"
                       [howdenMax]="9999999"/>
                <mat-error #aSurneCapitalAbsoluteDisabilityError></mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex f-gap--10px">
            <div class="f-basis--2">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.label">Total Permanente</mat-label>
                <input matInput type="number" inputmode="decimal" min="0" step="any"
                       formControlName="aSurneCapitalTotalPermanentDisability"
                       [howdenControlError]="aSurneCapitalTotalPermanentDisabilityError"
                       [howdenMax]="9999999"/>
                <mat-error #aSurneCapitalTotalPermanentDisabilityError></mat-error>
              </mat-form-field>
            </div>

            <div class="f-basis--3">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.label">Asistencia Sanitaria</mat-label>
                <mat-select formControlName="aSurneCapitalHealthDisabilityType"
                            [compareWith]="compareByIdNumber"
                            [howdenControlError]="aSurneCapitalHealthDisabilityTypeError">
                  @for (item of (accidentsSurne.getMasterValues('S_SURNE_CAPITALHEALTHDISABILITYTYPE') | howdenArraySort:'description'); track item.id) {
                    <mat-option [value]="item.id">{{ item.description }}</mat-option>
                  } @empty {
                    <mat-option disabled>No hay opciones disponibles</mat-option>
                  }
                </mat-select>
                <mat-error #aSurneCapitalHealthDisabilityTypeError></mat-error>
              </mat-form-field>
            </div>

            @if (showHivSurne) {
              <div class="f-basis--2">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">VIH / Hepatitis</mat-label>
                  <mat-select formControlName="aSurneRateIdHIVHepatitisInfection"
                              [compareWith]="compareByIdNumber"
                              [howdenControlError]="aSurneRateIdHIVHepatitisInfectionError">
                    @for (item of (accidentsSurne.getMasterValues('S_SURNE_CAPITALHIVHEPATITISINFECTION') | howdenArraySort:'id'); track item.id) {
                      <mat-option [value]="item.id">{{ item.description }}</mat-option>
                    } @empty {
                      <mat-option disabled>No hay opciones disponibles</mat-option>
                    }
                  </mat-select>
                  <mat-error #aSurneRateIdHIVHepatitisInfectionError></mat-error>
                </mat-form-field>
              </div>
            }
          </div>
        </div>

        @if (showTrace(accidentsSurne)) {
          <div class="f-basis--4">
            <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(accidentsSurne) || ''"></div>
          </div>
        }

        <div class="f-basis--2 group-result-rmbonus" style="flex-direction: column;">
          @if (accidentsSurne.chargeable) {
            <howden-label-value labelText="Prima" [value]="accidentsSurne.bonus | bonus"></howden-label-value>
            <br />
          } @else {
            @for (m of getMessages(accidentsSurne); track $index) {
              @if (m.blocking) {
                <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                <br />
              }
            }
          }

          @for (m of getMessages(accidentsSurne); track $index) {
            @if (!m.blocking) {
              <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
              <br />
            }
          }
        </div>

      </div>
    </mat-card-content>
    </mat-card>
  </div>

  <div class="flex margin-top-15 f-gap--10px" formGroupName="accidentsPrebal">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">ACCIDENTES PREVIS</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="accidentsPrebal.productName || ''"></howden-label-value>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex f-gap--10px" style="align-items:flex-start;">

          <div class="f-basis--6">
            <div class="flex f-gap--10px">
              <div class="f-basis--2">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Fallecimiento</mat-label>
                  <input matInput type="number" inputmode="decimal" min="0" step="any"
                         formControlName="aPrebalCapitalDeath"
                         [howdenControlError]="aPrebalCapitalDeathError"
                         [howdenMax]="9999999"/>
                  <mat-error #aPrebalCapitalDeathError></mat-error>
                </mat-form-field>
              </div>

              <div class="f-basis--2">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">F. Accte. Circulación</mat-label>
                  <input matInput type="number" inputmode="decimal" min="0" step="any"
                         formControlName="aPrebalCapitalDeathTrafficAccident"
                         [howdenControlError]="aPrebalCapitalDeathTrafficAccidentError"
                         [howdenMax]="9999999"/>
                  <mat-error #aPrebalCapitalDeathTrafficAccidentError></mat-error>
                </mat-form-field>
              </div>

              <div class="f-basis--6">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Inv. Abstr. Baremo E.</mat-label>
                  <mat-select formControlName="aPrebalCapitalDisabilityType"
                              [compareWith]="compareByIdNumber"
                              [howdenControlError]="aPrebalCapitalDisabilityTypeError">
                    @for (item of (accidentsPrebal.getMasterValues('S_PREBAL_CAPITALDISABILITYTYPE') | howdenArraySort:'description'); track item.id) {
                      <mat-option [value]="item.id">{{ item.description }}</mat-option>
                    } @empty {
                      <mat-option disabled>No hay opciones disponibles</mat-option>
                    }
                  </mat-select>
                  <mat-error #aPrebalCapitalDisabilityTypeError></mat-error>
                </mat-form-field>
              </div>

              <div class="f-basis--2">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Total Invalidez</mat-label>
                  <input matInput type="number" inputmode="decimal" min="0" step="any"
                         formControlName="aPrebalCapitalDisability"
                         [howdenControlError]="aPrebalCapitalDisabilityError"
                         [howdenMax]="9999999"/>
                  <mat-error #aPrebalCapitalDisabilityError></mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="flex f-gap--10px">
              <div class="f-basis--3">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Invalidez Permanente Progresiva 225</mat-label>
                  <mat-select formControlName="aPrebalHasSelectedCapitalDisability"
                              [compareWith]="compareByIdNumber"
                              [howdenControlError]="aPrebalHasSelectedCapitalDisabilityError">
                    @for (item of (accidentsPrebal.getMasterValues('S_PREBAL_HASSELECTEDCAPITALDISABILITY') | howdenArraySort:'description'); track item.id) {
                      <mat-option [value]="item.id">{{ item.description }}</mat-option>
                    } @empty {
                      <mat-option disabled>No hay opciones disponibles</mat-option>
                    }
                  </mat-select>
                  <mat-error #aPrebalHasSelectedCapitalDisabilityError></mat-error>
                </mat-form-field>
              </div>

              @if (showHivPrebal) {
                <div class="f-basis--2">
                  <mat-form-field class="field-inputs">
                    <mat-label i18n="@@app.sane-projects.calculator.label">VIH / Hepatitis</mat-label>
                    <mat-select formControlName="aPrebalRateIdHIVHepatitisInfection"
                                [compareWith]="compareByIdNumber"
                                [howdenControlError]="aPrebalRateIdHIVHepatitisInfectionError">
                      @for (item of (accidentsPrebal.getMasterValues('S_PREBAL_CAPITALHIVHEPATITISINFECTION') | howdenArraySort:'id'); track item.id) {
                        <mat-option [value]="item.id">{{ item.description }}</mat-option>
                      } @empty {
                        <mat-option disabled>No hay opciones disponibles</mat-option>
                      }
                    </mat-select>
                    <mat-error #aPrebalRateIdHIVHepatitisInfectionError></mat-error>
                  </mat-form-field>
                </div>
              }

              <div class="f-basis--3">
                <mat-form-field class="field-inputs">
                  <mat-label i18n="@@app.sane-projects.calculator.label">Asistencia Sanitaria</mat-label>
                  <mat-select formControlName="capitalHealthCareAccidents"
                              [compareWith]="compareByIdNumber"
                              [howdenControlError]="capitalHealthCareAccidentsError">
                    @for (mv of (accidentsPrebal.getMasterValues('S_PREBAL_CAPITALHEALTHCAREACCIDENTS') | howdenArraySort:'description'); track mv.id) {
                      <mat-option [value]="mv.id">{{ mv.description }}</mat-option>
                    } @empty {
                      <mat-option disabled>No hay opciones disponibles</mat-option>
                    }
                  </mat-select>
                  <mat-error #capitalHealthCareAccidentsError></mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          @if (showTrace(accidentsPrebal)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(accidentsPrebal) || ''"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus" style="flex-direction: column;">
            @if (accidentsPrebal.chargeable) {
              <howden-label-value labelText="Prima" [value]="accidentsPrebal.bonus | bonus"></howden-label-value>
              <br />
            } @else {
              @for (m of getMessages(accidentsPrebal); track $index) {
                @if (m.blocking) {
                  <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                  <br />
                }
              }
            }

            @for (m of getMessages(accidentsPrebal); track $index) {
              @if (!m.blocking) {
                <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
                <br />
              }
            }
          </div>

        </div>
      </mat-card-content>
    </mat-card>
  </div>
</form>
